// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"315":"bed2648a","400":"1381ea83","428":"75005003","479":"9b54686d","622":"edc871d3","676":"8e4fcd04","810":"50156776","828":"9dec5308"}[chunkId] + ".js";
};